import React, { Component } from "react";
import { connect } from "react-redux";

import ButtonStrip from "../Layout/components/ButtonStrip";
import BoxButton from "../Layout/components/BoxButton";
import General from "./components/General";
import Archivos from "./components/Archivos";
import ModalGenerateInterfaz from "./components/ModalGenerateInterfaz";

import {
  reiniciarEstado,
  showHideModalGenerateInterfaz,
  deleteArchivosInterfaz,
  archiveArchivosInterfaz
} from "./actions";
import { showModalConfirmAction } from "../Layout/actions";

class InterfazContable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabs: [
        {
          id: 0,
          caption: "Solicitudes",
          component: prps => <General {...prps} />
        },
        {
          id: 1,
          caption: "Archivos",
          component: prps => <Archivos {...prps} />
        }
      ],
      selected: 0,
      filter: false
    };
  }

  componentWillMount() {
    this.props.reiniciarEstado();
  }

  selectTab = (e, tab) => {
    e.preventDefault();
    this.setState({ selected: tab });
  };

  componentWillUnmount() {}

  render() {
    const { tabs, selected } = this.state;
    if (!this.props.elementos) return null;

    const buttons = [];
    buttons.push(
      <BoxButton
        key={`action[0][1]`}
        name="filter"
        onClick={e => this.setState({ filter: !this.state.filter })}
        title="Filtrar"
      />
    );
    if (this.state.selected === 0) {
      if (this.props.elementos.filter(x => x === "qWIBNqqK").count()) {
        buttons.push(
          <BoxButton
            key={`action[0][2]`}
            name="share-square-o"
            onClick={e => this.props.showHideModalGenerateInterfaz(true)}
            title="Generar interfaz"
          />
        );
      }
    }
    if (this.state.selected === 1) {
      if (this.props.elementos.filter(x => x === "g989UEXj").count()) {
        buttons.push(
          <BoxButton
            key={`action[0][4]`}
            name="archive"
            onClick={e =>
              this.props.showModalConfirmAction(
                true,
                "Esta seguro que desea archivar los archivos seleccionados?",
                () => this.props.archiveArchivosInterfaz()
              )
            }
            title="Archivar archivos"
          />
        );
      }
      if (this.props.elementos.filter(x => x === "XbSeLVnI").count()) {
        buttons.push(
          <BoxButton
            key={`action[0][3]`}
            name="trash"
            onClick={e =>
              this.props.showModalConfirmAction(
                true,
                "Esta seguro que desea eliminar los archivos seleccionados?",
                () => this.props.deleteArchivosInterfaz()
              )
            }
            title="Eliminar archivos"
            danger
          />
        );
      }
    }

    return (
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between"
        }}
      >
        <div style={{ height: "100%" }}>
          <div className="nav-container">
            <div className="nav-tabs-section">
              <ul className="nav-tabs-tabs">
                {tabs.map(x => {
                  return (
                    <li
                      key={`li01[${x.id}]`}
                      className={selected === x.id ? "active" : ""}
                    >
                      <a onClick={e => this.selectTab(e, x.id)}>{x.caption}</a>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="nav-main-section">
              <div className="">
                <ButtonStrip actions={buttons} />
              </div>
              <div className="nav-main-section-scrollable">
                {tabs[selected].component({
                  filter: this.state.filter
                })}
              </div>
            </div>
          </div>
        </div>
        <ModalGenerateInterfaz />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    elementos: state.layout.get("elementos"),
    user: state.signin.get("user")
  };
}

const mapDispatchToProps = {
  reiniciarEstado,
  showHideModalGenerateInterfaz,
  showModalConfirmAction,
  deleteArchivosInterfaz,
  archiveArchivosInterfaz
};

export default connect(mapStateToProps, mapDispatchToProps)(InterfazContable);
